import * as tslib_1 from "tslib";
import { HttpParams } from '@angular/common/http';
import { Subject } from 'rxjs';
import { BaseProvider } from './base-provider';
import * as i0 from "@angular/core";
import * as i1 from "./globals.service";
import * as i2 from "@angular/common/http";
import * as i3 from "./ls-helper.service";
import * as i4 from "../../pages/transaction/services/transaction-requirement.service";
import * as i5 from "./utils.service";
import * as i6 from "../../pages/transaction/services/transaction.service";
export class DynamicFormService extends BaseProvider {
    constructor(globals, http, ls, transactionRequirementService, utilsService, transactionService) {
        super();
        this.globals = globals;
        this.http = http;
        this.ls = ls;
        this.transactionRequirementService = transactionRequirementService;
        this.utilsService = utilsService;
        this.transactionService = transactionService;
        this.isLinear = false;
        this.isReadOnly = false;
        this.isInRevisionMode = false;
        this.isComplete = false;
        this.isLoadingForm = false;
        this.formLoaderIsVisible = false;
        this.formCommunicator = new Subject();
        this.revisionMode = false;
        this.baseUrl = 'userProcessRequirement';
    }
    save(data) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/dynamicForm/requirement/' + this.requirement.UserProcessRequirementId +
                '/process/' + this.requirement.ProcessId +
                '/complete/' + this.isComplete;
            this.http
                .post(this.url, data)
                .subscribe((data) => {
                const item = data.Data;
                this.transactionRequirementService.updateItemByField(item.UserProcessRequirementId, 'UserProcessRequirementId', item);
                this.transactionService.getById(this.transactionService.itemToEdit.Id);
                resolve(item);
            }, err => { reject(err); });
        });
    }
    saveImage(data, extensionIMG) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/dynamicForm/requirement/' + this.requirement.UserProcessRequirementId +
                '/photo';
            data.extensionIMG = extensionIMG;
            this.http
                .post(this.url, data)
                .subscribe((data) => {
                const item = data.Data;
                this.transactionRequirementService.updateItemByField(item.UserProcessRequirementId, 'UserProcessRequirementId', item);
                this.transactionService.transactionRefresher.next();
                resolve(item);
            }, err => { reject(err); });
        });
    }
    saveExcel(data) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/dynamicForm/requirement/' + this.requirement.UserProcessRequirementId +
                '/excel';
            this.http
                .post(this.url, data)
                .subscribe((data) => {
                const item = data.Data;
                this.transactionRequirementService.updateItemByField(item.UserProcessRequirementId, 'UserProcessRequirementId', item);
                this.transactionService.transactionRefresher.next();
                resolve(item);
            }, err => { reject(err); });
        });
    }
    readExcel(file) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/readExcel/';
            const formData = new FormData();
            formData.append('file', file, file.name);
            formData.append('processId', this.requirement.ProcessId);
            this.http
                .post(this.url, formData)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    saveCosts(costs) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/dynamicForm/process/' + this.requirement.ProcessId +
                '/costs';
            const costsStr = JSON.stringify(costs);
            this.http
                .post(this.url, { costs: costsStr })
                .subscribe((data) => {
                resolve(null);
            }, err => { reject(err); });
        });
    }
    saveIndex(index) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/dynamicForm/requirement/' + this.requirement.UserProcessRequirementId +
                '/index';
            this.http
                .post(this.url, { index })
                .subscribe((data) => {
                resolve(null);
            }, err => { reject(err); });
        });
    }
    getByModuleName(moduleName) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/dynamicForm/module/' + moduleName;
            this.http.get(this.url)
                .subscribe((data) => {
                const item = data.Data;
                resolve(item);
            }, err => { reject(err); });
        });
    }
    getCadastreNumber() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/dynamicForm/cadastreNumber/' + this.transactionService.itemToEdit.Id;
            this.http.get(this.url)
                .subscribe((data) => {
                const item = data.Data;
                resolve(item);
            }, err => { reject(err); });
        });
    }
    uploadFileQuerellaForm(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/uploadFile';
            this.http
                .post(this.url, params)
                .subscribe((data) => {
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getFileQuerellaForm(fileName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParams = new HttpParams().set('fileName', fileName.toString());
            return yield new Promise((resolve, reject) => {
                this.url = `${this.globals.dataUrl}${this.baseUrl}/getFileQuerellaForm`;
                this.http
                    .get(this.url, { responseType: 'arraybuffer', params: queryParams })
                    .subscribe((data) => {
                    const blob = new Blob([data], { type: this.getMimeType(fileName) });
                    const url = window.URL.createObjectURL(blob);
                    resolve(url);
                }, err => { reject(err); });
            });
        });
    }
    /**
     * Limpia todos los datos relacionados con los formularios dinámicos
     * Se llama cuando se abandona el componente transaction-management
     */
    clearDynamicFormData() {
        this.isLinear = false;
        this.isReadOnly = false;
        this.isInRevisionMode = false;
        this.isComplete = false;
        this.isLoadingForm = false;
        this.costTypeId = null;
        this.formLoaderIsVisible = false;
        this.formName = null;
        this.requirement = null;
        this.revisionMode = false;
        // Limpiar formCommunicator
        this.formCommunicator = new Subject();
        console.log('DynamicFormService: datos limpiados');
    }
    getMimeType(fileName) {
        // Determinar el tipo MIME basado en la extensión del archivo
        const fileExtension = fileName.split('.').pop().toLowerCase();
        let mimeType = 'application/octet-stream'; // tipo por defecto
        switch (fileExtension) {
            case 'pdf':
                mimeType = 'application/pdf';
                break;
            case 'jpg':
            case 'jpeg':
                mimeType = 'image/jpeg';
                break;
            case 'png':
                mimeType = 'image/png';
                break;
            case 'gif':
                mimeType = 'image/gif';
                break;
            case 'doc':
                mimeType = 'application/msword';
                break;
            case 'docx':
                mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                break;
            case 'xls':
                mimeType = 'application/vnd.ms-excel';
                break;
            case 'xlsx':
                mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                break;
            case 'txt':
                mimeType = 'text/plain';
                break;
        }
        return mimeType;
    }
}
DynamicFormService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DynamicFormService_Factory() { return new DynamicFormService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.LsHelperService), i0.ɵɵinject(i4.TransactionRequirementService), i0.ɵɵinject(i5.UtilsService), i0.ɵɵinject(i6.TransactionService)); }, token: DynamicFormService, providedIn: "root" });
